import { Component } from '@angular/core';
import { environment } from '../../../../../../public/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/Api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-careers',
  standalone: false,
  templateUrl: './careers.component.html'
})
export class CareersComponent {
  dataLoading = true;
  loadMoreLoading = false;
  jobs: any = [];
  listData: any;
  env = environment;
  pageIndx = 1;

  company_id: any;

  language: any;

  viewStyle = 1;

  mainColor = '#5252d8';
  mainColorWithoutHash!: any;

  titleColor = '#4d5b70';
  titleColorWithoutHash!: any;

  textColor = '#6B6B7C';
  textColorWithoutHash!: any;

  backgroundColor = '#f8f8ff';
  backgroundColorWithoutHash!: any;

  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['company_id']) {
        this.company_id = params['company_id'];
      }

      if (params['language'] && (params['language'] === 'ar' || params['language'] === 'en')) {
        this.language = params['language'];
        const paramLang = params['language'];
        const storedLang = localStorage.getItem('language');

        if (storedLang !== paramLang) {
          this.translate.use(paramLang);
          localStorage.setItem('language', paramLang);
          document.documentElement.setAttribute('dir', paramLang === 'ar' ? 'rtl' : 'ltr');
          return;
        }
      }

      if (params['color']) {
        this.mainColor = '#' + params['color'];
        this.mainColorWithoutHash = params['color'];
        document.documentElement.style.setProperty('--primary', this.mainColor);
      }

      if (params['title_color']) {
        this.titleColor = '#' + params['title_color'];
        this.titleColorWithoutHash = params['title_color'];
        document.documentElement.style.setProperty('--gray-0', this.titleColor);
      }

      if (params['font_color']) {
        this.textColor = '#' + params['font_color'];
        this.textColorWithoutHash = params['font_color'];
        document.documentElement.style.setProperty('--gray-2', this.textColor);
      }

      if (params['background_color']) {
        this.backgroundColor = '#' + params['background_color'];
        this.backgroundColorWithoutHash = params['background_color'];
        document.documentElement.style.setProperty('--background_primary_ff', this.backgroundColor);
      }
    });
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    if (this.pageIndx == 1) {
      this.jobs = [];
    }
    let filter: any = { perPage: 8, page: this.pageIndx };
    if (this.company_id) {
      filter.company_id = this.company_id;
    }
    if (this.language) {
      filter.language = this.language;
    }
    this.apiService.getCompanyJobs(filter).subscribe((res: any) => {
      this.listData = res.data;
      this.jobs = this.jobs.concat(res.data.list);
      this.dataLoading = false;
      this.loadMoreLoading = false;
    })
  }

  loadMore() {
    this.pageIndx += 1;
    this.loadMoreLoading = true;
    this.getData();
  }
}
